module.exports = __webpack_public_path__ + "img/Group 33696.78932908.svg";